;(function module() {
  angular.module('app.ui.form.ctrls').controller('PracticeAreaController', [
    '$uibModalInstance',
    'practiceAreaList',
    'selectedPractice',
    'practiceAreaService',
    'limit',
    'logger',
    'isAdminProfile',
    'displayNextButton',
    function controller(
      $uibModalInstance,
      practiceAreaList,
      selectedPractice,
      practiceAreaService,
      limit,
      logger,
      isAdminProfile,
      displayNextButton
    ) {
      let vm = this

      // Setting practiceArea list in this controller scope.
      vm.practiceAreasList = angular.copy(practiceAreaList)
      vm.displayNextButton = displayNextButton

      if (selectedPractice)
        practiceAreaService.initialize(
          selectedPractice,
          vm.practiceAreasList,
          false
        )

      /** This method will expand practice area on '+' is clicked
       */
      vm.expandChildPracticeArea = practiceArea => {
        practiceArea.showChildren = true
      }

      /** This method will collapse practice area on '-' is clicked
       */
      vm.collapseChildPracticeArea = practiceArea => {
        practiceArea.showChildren = false
      }

      /** When clicking 'save' button this method will save only selected child practice area from modal
       */
      vm.save = () => {
        const selectedPracticeArea = practiceAreaService.setIsSelectedChildrenPracticeArea(
          vm.practiceAreasList,
          []
        )
        if (selectedPracticeArea.length === 0 && !isAdminProfile)
          logger.notify('warning', 'Please select at least one Practice Area.')
        else if (limit && selectedPracticeArea.length > limit)
          logger.notify(
            'error',
            `You are allowed to choose a maximum of ${limit} practice areas.`
          )
        else $uibModalInstance.close(selectedPracticeArea)
      }

      /**  When clicking 'cancel' button this method will closed modal
       */
      vm.cancel = () => {
        $uibModalInstance.dismiss('cancel')
      }

      /** This method will make selected practice area checked or unchecked and make parent and child selected and unselected
       * @param  {} selectedValue practice area
       * @param  {} event checked or unchecked
       */
      vm.selectPracticeArea = (selectedValue, event) => {
        if (limit > 0) {
          let count = getSelectedCount(
            vm.practiceAreasList.filter(practiceArea => practiceArea.isSelected)
          )
          practiceAreaService.selectOrDeselectAllPractices(
            [selectedValue],
            true
          )

          count = event.target.checked
            ? selectedValue.children
              ? count + getSelectedCount([selectedValue])
              : count + 1
            : selectedValue.children
            ? count - getSelectedCount([selectedValue])
            : count - 1

          if (count > 0 && count > limit - 5 && count < limit) {
            if (count >= 4)
              logger.notify(
                'warning',
                'You are approaching the limit for practice area selections.'
              )
          }

          if (count > 0 && count === limit)
            logger.notify(
              'warning',
              ' You have reached the limit for practice area selections, please refine your expertise to only those practice areas you have actual experience in.'
            )
          else if (count > 0 && count > limit) {
            logger.notify(
              'error',
              `You are allowed to choose a maximum of ${limit} practice areas.`
            )
            selectedValue.isSelected = false
            event.target.checked = false
          }
        }

        practiceAreaService.selectPracticeArea(
          vm.practiceAreasList,
          selectedValue,
          event
        )
      }
    },
  ])
})()

const getSelectedCount = allPractices => {
  // eslint-disable-next-line unicorn/no-reduce
  return allPractices.reduce((count, practiceArea) => {
    if (practiceArea.isSelected) {
      if (practiceArea.children) {
        return count + getSelectedCount(practiceArea.children)
      }

      count += 1
    }

    return count
  }, 0)
}



// WEBPACK FOOTER //
// ./scripts/shared/directives/practice-area/practice-area-modal.ctrl.js